import PencilIcon from '~shared/assets/icons/pencil.svg?react';
import TrashIcon from '~shared/assets/icons/trash.svg?react';

import { Button } from '@breezeventures/ui-kit/button';
import { Typography } from '@breezeventures/ui-kit/typography';

export type ItemProps<T> = {
  id: T;
  primaryText: string;
  secondaryText?: string;
  errorText?: string;
  onEdit?: (id: T) => void;
  onRemove?: (id: T) => void;
};

export const Item = <T,>({
  id,
  primaryText,
  secondaryText,
  errorText,
  onEdit,
  onRemove,
}: ItemProps<T>) => {
  return (
    <div className="flex flex-col">
      <div
        className={`
          flex items-center justify-between gap-3 rounded-xl border
          border-neutral-100 p-4 shadow-custom-md
        `}
      >
        <div className="min-w-0 flex-1">
          <Typography.Text size="m" weight="medium">
            {primaryText}
          </Typography.Text>
          {secondaryText && (
            <Typography.Text
              size="s"
              color="secondary"
              className="mt-1 truncate"
            >
              {secondaryText}
            </Typography.Text>
          )}
        </div>

        {onEdit && (
          <Button
            size="s"
            variant="secondary"
            className="size-10 shrink-0"
            aria-label="Edit"
            onClick={() => onEdit(id)}
          >
            <PencilIcon />
          </Button>
        )}

        {onRemove && (
          <Button
            size="s"
            variant="secondary"
            className="size-10 shrink-0"
            aria-label="Delete"
            onClick={() => onRemove(id)}
          >
            <TrashIcon />
          </Button>
        )}
      </div>

      {errorText && (
        <Typography.Text size="xs" color="negative" className="pt-2 pl-2">
          {errorText}
        </Typography.Text>
      )}
    </div>
  );
};
